import axios from 'axios';
import { pick } from 'lodash';
import { IOrganizationInfo } from '@pec/aion-ui-core/interfaces/organizationInfo';
import { _DeepReadonlyObject } from 'utility-types/dist/mapped-types';
import { IUserInfo } from '@pec/aion-ui-core/interfaces/userInfo';
import { IMainSubscription } from '@pec/aion-ui-core/interfaces/mainSubscription';
import { OperationType } from '../types/enums';
import { IDiscount } from '../surveyjs/common/components/questionTypes/MuiDiscount';

type Products = {
  productCodes: string[];
  productIds: string[];
};

export type Payload = {
  organizationInfo: IOrganizationInfo;
  userInfo: _DeepReadonlyObject<IUserInfo> | null;
  mainSubscription: IMainSubscription;
  operationType: string;
  products: Products | null;
  quantity?: number;
  stepName?: string;
  stepNumber?: number;
  url?: string;
  discountCode?: IDiscount | null;
};
export const updateLead = async (payload: Payload) => {
  const {
    organizationInfo,
    userInfo,
    mainSubscription,
    products,
    operationType,
    quantity,
    stepName,
    stepNumber,
    url,
    discountCode
  } = payload;
  const thirdPartyAddon = operationType === OperationType.ThirdPartyAddon;

  try {
    const body = {
      ...(thirdPartyAddon && {
        user: { ...pick(userInfo, ['firstName', 'lastName', 'phoneNumber']), email: userInfo?.emailAddress }
      }),
      operationType: operationType,
      stepName: stepName ?? '',
      stepNumber: stepNumber ?? 1,
      organization: {
        companyId: organizationInfo.legacyId,
        currentSubscriptionTier: mainSubscription.description,
        dataSharingConsent: null,
        expirationDateUtc: mainSubscription.expirationDate,
        organizationId: organizationInfo.id,
        package: {
          ...pick(organizationInfo, ['applicationType', 'assessmentType', 'companyType']),
          location: mainSubscription.countryISO2,
          addToSupplyChainClientId: null,
          discountCode: discountCode ? discountCode.code : null,
          discountCodeId: discountCode ? discountCode.id : null,
          ...(thirdPartyAddon && { quantity: quantity ?? null }),
          productCodes: products?.productCodes || [],
          productIds: products?.productIds || []
        },
        subcontractorEmployeeCount: organizationInfo.employeeCount.subcontractorEmployeeCount,
        totalEmployeeCount: organizationInfo.employeeCount.employeeCount,
        url: url ?? window.location.href.replace(/\/membership|dashboard/g, '').split('?')[0]
      }
    };

    await axios.post('/api/v1/progress', body);
  } catch (e) {}
};
